import { frontendURL } from '../../../../helper/URLHelper';

const conversations = accountId => ({
  parentNav: 'conversations',
  routes: [
    'home',
    'inbox_dashboard',
    'inbox_conversation',
    'conversation_through_inbox',
    'notifications_dashboard',
    'label_conversations',
    'conversations_through_label',
    'team_conversations',
    'conversations_through_team',
    'conversation_mentions',
    'conversation_through_mentions',
    'conversation_participating',
    'conversation_through_participating',
    'folder_conversations',
    'conversations_through_folders',
    'conversation_unread',
    'conversation_through_unread',
    'conversation_agent_handled',
    'conversation_through_agent_handled',
    'conversation_not_handled',
    'conversation_through_not_handled',
    'scheduled_messages',
  ],
  menuItems: [
    {
      icon: 'chat',
      label: 'ALL_CONVERSATIONS',
      key: 'conversations',
      toState: frontendURL(`accounts/${accountId}/dashboard`),
      toolTip: 'Conversation from all subscribed inboxes',
      toStateName: 'home',
    },
    {
      icon: 'mention',
      label: 'MENTIONED_CONVERSATIONS',
      key: 'conversation_mentions',
      toState: frontendURL(`accounts/${accountId}/mentions/conversations`),
      toStateName: 'conversation_mentions',
    },
    {
      icon: 'mail-unread',
      label: 'UNREAD_CONVERSATIONS',
      key: 'conversation_unread',
      toState: frontendURL(`accounts/${accountId}/unread/conversations`),
      toStateName: 'conversation_unread',
    },
    {
      icon: 'checkmark-double',
      label: 'AGENT_HANDLED_CONVERSATIONS',
      key: 'conversation_agent_handled',
      toState: frontendURL(`accounts/${accountId}/agent-handled/conversations`),
      toStateName: 'conversation_agent_handled',
    },
    {
      icon: 'person-add',
      label: 'NOT_HANDLED_CONVERSATIONS',
      key: 'conversation_not_handled',
      toState: frontendURL(`accounts/${accountId}/not-handled/conversations`),
      toStateName: 'conversation_not_handled',
    },
  ],
});

export default conversations;
